import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import { authModule } from "./auth/index";
import { commonModule } from "./common/index";
import { assistantsModule } from "./assistants/index";
export default new Vuex.Store({
  namespaced: true,
  state: {
    isUnloadListenerAttached: false
  },
  mutations: {
    attachUnloadListener(state, payload) {
      state.isUnloadListenerAttached = true
      state.onBeforeUnload = payload.onBeforeUnload
      window.addEventListener('beforeunload', payload.onBeforeUnload)
    },
    removeUnloadListener(state) {
      state.isUnloadListenerAttached = false
      window.removeEventListener('beforeunload', state.onBeforeUnload)
      state.onBeforeUnload = null
    },
    clearSearchBox() {
      console.log('clearing search box...')
    }
  },
  actions: {},
  modules: {
    authModule,
    commonModule,
    assistantsModule
  }
});
